import React, {useContext, useEffect} from 'react';
import {VerticalStepperWithContainer} from "./VerticalStepperWithContainer";
import {UserContext} from "../context";
import {useNavigate} from "react-router-dom";

export const ChangingThoughtsWithAnAI = () => {
    const user = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (user == null) {
            navigate('/');
        }
    }, [navigate, user]);

    return user && (
        <>
            <div>
                <br/>
                <h1>Changing Thoughts with AI</h1>
                <br/>
                <VerticalStepperWithContainer />
            </div>
        </>
    );
}
